import * as indexApi from '@api/indexApi'
const state = {
  customerInfo: null, // 企业信息
  airport: null, // 机场城市数据
  domAirport: null, // 机场城市数据
  intAirport: null, // 机场城市数据
  dict: null, // 数据字典数据
  aircodedata: null, // 航司数据
  country: null, // 国籍
  accountInfo: null, // 登录账号信息
  keepAliveArr: [] // 缓存页面
}
const mutations = {
  setCustomerInfo (indexStore, data) {
    indexStore.customerInfo = data
  },
  setAirport (indexStore, data) {
    indexStore.airport = data || {
      airportList: [...(((indexStore.domAirport || {}).airportList) || []), ...(((indexStore.intAirport || {}).airportList) || [])],
      airportMap: { ...(((indexStore.domAirport || {}).airportMap) || {}), ...(((indexStore.intAirport || {}).airportMap || {})) },
      shortNameMap: { ...(((indexStore.domAirport || {}).shortNameMap) || {}), ...(((indexStore.intAirport || {}).shortNameMap) || {}) }
    }
  },
  setDomAirport (indexStore, data) {
    indexStore.domAirport = data
  },
  setIntAirport (indexStore, data) {
    indexStore.intAirport = data
  },
  setDict (indexStore, data) {
    indexStore.dict = data
  },
  setAirCodeData (indexStore, data) {
    indexStore.aircodedata = data
  },
  setCountry (indexStore, data) {
    indexStore.country = data
  },
  setAccountInfo (indexStore, data) {
    indexStore.accountInfo = data
  },
  setKeepAliveArr (indexStore, data) {
    indexStore.keepAliveArr = data || []
  }
}
const actions = {
  async getAirport ({ commit, state }) {
    if (!state.airport || !state.airport.airportList.length || state.airport.airportList.items) {
      const { data: res } = await indexApi.getAirCityData()
      commit('setAirport', res.data)
    }
  },
  async getDomAirport ({ commit, state }) {
    if (!state.domAirport || !state.domAirport.airportList.length || state.domAirport.airportList.items) {
      const { data: res } = await indexApi.getAirport({
        isSign: 'D'
      })
      commit('setDomAirport', res.data)
    }
    commit('setAirport')
  },
  async getIntAirport ({ commit, state }) {
    if (!state.intAirport || !state.intAirport.airportList.length || state.intAirport.airportList.items) {
      const { data: res } = await indexApi.getAirport({
        isSign: 'I'
      })
      commit('setIntAirport', res.data)
    }
    commit('setAirport')
  },
  async setDict ({ commit, state }) {
    if (!state.dict) {
      const { data: res } = await indexApi.getDict()
      commit('setDict', res.data)
    }
  },
  async setAirCodeData ({ commit, state }) {
    if (!state.aircodedata) {
      const { data: res } = await indexApi.getAirCodeData()
      commit('setAirCodeData', res.data)
    }
  },
  async setCountry ({ commit, state }) {
    if (!state.country) {
      const { data: res } = await indexApi.getCountry()
      commit('setCountry', res.data)
    }
  },
  async getCustomerInfo ({ commit, state }) {
    if (!state.customerInfo) {
      const { data: res } = await indexApi.getPassengerById({
        id: state.accountInfo.passengerId
      })
      commit('setCustomerInfo', res.data)
    }
  }
}
export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/indexStore.js